export default __webpack_public_path__ + "9123cee068f0b321df588e91d06a1afb.png";